<div [attr.data-tooltip]="user()?.display_name" class="user-preview">
  <img src="{{ user()?.image }}" alt="{{ user()?.display_name }}" />
</div>
